import { Editor } from 'grapesjs';
import { LinkRenderer } from '@loyalty/editor-components';
import { faLink } from '@fortawesome/pro-solid-svg-icons/faLink';
import { EditorComponentDefinition } from '../types';
import { EditorContext } from '../../../services/editor-service';
import { LinkWidgetTraits } from './LinkWidgetTraits';
import { Toolbar, buildParticipantContextFromGrape } from '../../utils';
import { translateAttributes } from '../../../services/copy-paste/copy-paste-utils';

export const linkComponentDefinition: EditorComponentDefinition = {
  id: 'custom-link',
  icon: faLink,
  category: 'Content',
  getLabel: ({ t }) => t('editor.component.link'),
  component: LinkGrapesComponent,
  copyPasteHelper: (element, context) => translateAttributes(element, context.destinationLocales),
  traits: {
    form: LinkWidgetTraits,
  },
};

export function LinkGrapesComponent(editor: Editor) {
  const i18n = editor.I18n;
  const context: EditorContext = editor.Config.context;

  editor.DomComponents.addType(linkComponentDefinition.id, {
    model: {
      defaults: {
        traits: [],
      },
      initToolbar: Toolbar,
      toHTML(): string {
        return LinkRenderer(
          {
            state: context.widgetState,
            options: {
              id: this.getId(),
              attributes: this.getAttributes(),
              i18nAttributes: this.attributes.i18nAttributes || {},
            },
            context: buildParticipantContextFromGrape(i18n),
          },
          editor.Canvas.getDocument(),
        );
      },
    },
    view: {
      onRender() {
        const { el, model } = this;
        el.innerHTML = model.toHTML();
      },
    },
  });
}
